import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/super')({
  component: SuperLayout,
})

function SuperLayout() {
  return <Outlet />
}
